import ReactGA from "react-ga4";
import { getLocalCompanyId, getLocalUser } from "../functions/utilities";

const useAnalyticsEventTracker = (category) => {
    const companyId = getLocalCompanyId();
    const user = getLocalUser();
    const eventTracker = (action, label?, extraDimensions = {}) => {
        if (companyId != import.meta.env.VITE_MERITO_COMPANY_ID) {
            console.log("companyId", companyId != import.meta.env.VITE_MERITO_COMPANY_ID)
            console.log("extra dimensions", extraDimensions, action)
            ReactGA.event({ category, action, label, ...extraDimensions });
        }

    }
    return eventTracker;
}

export default useAnalyticsEventTracker;